import Vue from "vue";
import App from "./App.vue";

import VueRout from 'vue-router'

import router from './router'
import { VueJsonp } from 'vue-jsonp'
import { Carousel,CarouselItem } from "element-ui";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import Vue from 'vue';
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// import App from './App.vue';

// Vue.use(ElementUI);
//
// new Vue({
//   el: '#app',
//   render: h => h(App)
// });
Vue.use(ElementUI);
Vue.use(VueJsonp)
Vue.use(VueRout)
Vue.use(Carousel)
Vue.use(CarouselItem)
//关闭Vue的生产提示
Vue.config.productionTip = false

new Vue({
  router,
  el: '#app',
  render: (h) => h(App),
}).$mount("#app");


// //引入Vue
// import Vue from 'vue'
// //引入App
// import App from './App.vue'

// import VueRout from 'vue-router'

// import router from './router'

// Vue.use(VueRout)
// //关闭Vue的生产提示
// Vue.config.productionTip = false


// //创建vm
// new Vue({
// 	el: '#app',
// 	render: h => h(App),
// 	router: router
// })
